export default "__VITE_ASSET__ad3167f8__"